import AccountPage from './pages/AccountPage'

export const UserRoutes = [
  {
    path: '/account',
    name: 'Account',
    component: AccountPage,
    meta: {
      requiresAuth: true
    }
  }
  /* {
      path: '/signup',
      component: SignUpPage
    }*/
]
